import { fetchCoachName } from 'api/signup.api.js'

module.exports = {
  sendPayment: function(token) {
    return { type: 'SEND_PAYMENT', token };
  },
  confirmPayment: function(conf) {
    return { type: 'CONFIRM_PAYMENT', conf };
  },
  setProfile: function(profile){
    return { type: 'SET_PROFILE', profile };
  },
  submitEmail: function(email, name){
    return { type: 'SUBMIT_EMAIL', email, name };
  },
  athleteUseAccessCode: function(accessCode, profile){
    return { type: 'ATHLETE_USE_ACCESS_CODE', accessCode, profile };
  },
  boxPay: function(token){
    return { type: 'BOX_PAY', token };
  },
  dhrCoachPay: function(token){
    return { type: 'DHR_COACH_PAY', token };
  },
  initUserAcct: (data) => (
    { type: 'INIT_USER_ACCT', data }
  ),
  fetchCoachName: (orgId) => async (dispatch) => {
    const response = await fetchCoachName(orgId);
    return response;
  }
};



// WEBPACK FOOTER //
// ./src/actions/signUpActions.js